import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const ButtonWrapper = styled.div(() =>
  mq({
    width: ['295px', '295px', '320px', '320px'],
    margin: `${defaultTheme.spacing.xxl} auto 0 auto`,
  }),
);
